common.View.create('admin::layouts.main.header.RightHalf', {

    onDOMLoad() {
        this.clearStorageOnLogout();
    },

    clearStorageOnLogout() {
        this.element.find('.logout-button').on('click', () => {
            localStorage.clear();
        });
    }
});
